import React, { useEffect, useMemo, useState } from "react";
import Header from "../../layout/Header";
import { getColumns } from "./listColumn";
import { getDisplayDate } from "../../../utils/helper";
import Paginated from "./Paginated";
import {
    getQRCode,
    getQRTemplate,
    updateQRStatus,
} from "../../../services/services";
import { Button, Modal } from "react-bootstrap";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import { decrypt } from "../../../utils/encodingdecoding";
import { arjunMerchantId, starblazeMerchantId } from "../../../utils";

const QRCodeList = () => {
    const [loader, setLoader] = useState(false);
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [qrCount, setQrCount] = useState(0);

    const [templates, setTemplates] = useState([]);
    const [templateList, setTemplateList] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [selectedBatch, setSelectedBatch] = useState(null);

    const [showModal, setShowModal] = useState(false);
    const [selectedQR, setSelectedQR] = useState(null);

    const currentPage = JSON.parse(localStorage.getItem("QRPageIndex")) || 1;
    const merCode = localStorage.getItem("Id");
    const COLUMNS = useMemo(() => getColumns(), []);

    useEffect(() => {
        localStorage.setItem("QRPageIndex", JSON.stringify(1));
        initTemplates();
    }, []);

    const initTemplates = async () => {
        try {
            setLoader(true);
            const tokenRes = JSON.parse(localStorage.getItem("token_gen"));

            const templateRes = await getQRTemplate(tokenRes.access_token);
            const productList = templateRes?.data || [];

            const validProducts = productList.filter(
                item => Number(item?.totalqrcodecount) > 0
            );

            setTemplates(productList);

            setTemplateList(
                validProducts?.map(item => ({
                    label: item.productName,
                    value: item.code,
                    batchNo: item?.others?.subCategory
                }))
            );

            if (validProducts.length > 0) {
                setSelectedTemplate(validProducts[0].code);
            } else {
                setSelectedTemplate("");
            }

        } catch (err) {
            console.error("Template API error:", err);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        if (selectedTemplate || selectedBatch) {
            fetchQRList(currentPage, 50, selectedTemplate, selectedBatch);
        }
    }, [selectedTemplate, selectedBatch]);

    const fetchQRList = async (page, pageSize = 50, templateCode, selectedBatch) => {
        try {
            setLoader(true);

            const tokenRes = JSON.parse(localStorage.getItem("token_gen"));

            const response = await getQRCode(
                tokenRes.access_token,
                merCode,
                templateCode,
                selectedBatch,
                page,
                pageSize
            );

            if (response?.message === "Record fetched successfully.") {
                const mappedData = response.data.map((ele) => {
                    const matchedProduct = templates.find(
                        (p) => p.code === ele.templatecode
                    );

                    return {
                        ...ele,
                        qr: ele.qrcode ?? "",
                        encryptCode: ele.code
                            ? ele.code.toString().slice(0, -4) + "****"
                            : "",
                        productName: matchedProduct?.productName || "",
                        status:
                            ele.status === "Active" ? (
                                "Un Scan"
                            ) : (
                                <span class="text-danger"
                                // style={{ color: "red", cursor: "pointer" }}
                                // onClick={() => handleShow(ele)}
                                >
                                    Scanned
                                </span>
                            ),
                        createddate: getDisplayDate(ele.createddate),
                        scandate: ele.status?.toLowerCase() === "inactive" ?
                            getDisplayDate(ele.updateddate) : "",
                        // customerCode: <Link to={`/customer-view/${ele?.customerCode}`}>{ele?.customerCode}</Link>

                    };
                });

                const reversed = mappedData.reverse();
                setData(reversed);
                setFilteredData(reversed);
                setQrCount(response.totalCount);
            } else {
                setData([])
                setQrCount(0);
                setFilteredData([]);
            }
        } catch (err) {
            console.error("QR fetch error:", err);
        } finally {
            setLoader(false);
        }
    };

    const handleShow = (qr) => {
        setSelectedQR(qr);
        setShowModal(true);
    };

    const handleClose = () => setShowModal(false);

    const updateQRCodeStatus = async () => {
        try {
            setLoader(true);
            const tokenRes = JSON.parse(localStorage.getItem("token_gen"));
            await updateQRStatus(tokenRes.access_token, selectedQR?.code, "Active");
            fetchQRList(currentPage, 50, selectedTemplate);
        } finally {
            setLoader(false);
        }
    };

    const fetchAllQRByTemplate = async (templateCode) => {
        try {
            setLoader(true);

            const tokenRes = JSON.parse(localStorage.getItem("token_gen"));

            const response = await getQRCode(
                tokenRes.access_token,
                merCode,
                templateCode,
                "",
                ""
            );

            if (response?.message === "Record fetched successfully.") {
                return response.data.map((ele) => {
                    const matchedProduct = templates.find(
                        (p) => p.code === ele.templatecode
                    );

                    return {
                        ...ele,
                        qr: ele.qrcode ?? "",
                        productName: matchedProduct?.productName || "",
                        isassigned: ele.isassigned?.toString(),
                        createddate: getDisplayDate(ele.createddate),
                        status: ele.status === "Active" ? "Un Scan" : "Scan",
                    };
                });
            }

            return [];
        } catch (error) {
            console.error("fetchAllQRByTemplate error:", error);
            return [];
        } finally {
            setLoader(false);
        }
    };


    const handleDownloadCSV = async () => {
        const allData = await fetchAllQRByTemplate(selectedTemplate);
        if (!allData.length) return;

        try {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("QR Code Data");

            const hasQrImage = decrypt(merCode) !== starblazeMerchantId &&
                allData.some(
                    (row) => row.qr && row.qr.startsWith("data:image")
                );

            const headers = hasQrImage
                ? [
                    "QR Image",
                    "QR Code",
                    "Template Code",
                    "Product Name",
                    "Is Assign",
                    "Created Date",
                    "Status",
                ]
                : [
                    "QR Code",
                    "Template Code",
                    "Product Name",
                    "Is Assign",
                    "Created Date",
                    "Status",
                ];

            worksheet.columns = headers.map((key) => ({
                header: key,
                key,
                width: key === "QR Image" ? 20 : 30,
            }));

            allData.forEach((row, index) => {
                const rowIndex = index + 2;

                const formattedDate = row.createddate
                    ? new Date(row.createddate).toLocaleDateString("en-US")
                    : "";

                const newRow = {
                    "QR Code": row.code ?? "",
                    "Template Code": row.templatecode ?? "",
                    "Product Name": row.productName ?? "",
                    "Is Assign": row.isassigned ? "Yes" : "No",
                    "Created Date": formattedDate,
                    "Status": typeof row.status === "string" ? row.status : "Scan",
                };

                worksheet.addRow(newRow);

                if (hasQrImage) {
                    worksheet.getRow(rowIndex).height = 90;
                }

                if (
                    hasQrImage &&
                    row.qr &&
                    row.qr.startsWith("data:image")
                ) {
                    const imageId = workbook.addImage({
                        base64: row.qr,
                        extension: "png",
                    });

                    worksheet.addImage(imageId, {
                        tl: { col: 0, row: rowIndex - 1 },
                        ext: { width: 90, height: 90 },
                    });
                }
            });

            const buffer = await workbook.xlsx.writeBuffer();

            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            saveAs(blob, "QR_Code_Data.xlsx");
        } catch (error) {
            console.error("Error generating Excel:", error);
        }
    };

    const handleDownloadQRImagesZip = async () => {
        const allData = await fetchAllQRByTemplate(selectedTemplate);

        if (!allData.length) return;

        try {
            const zip = new JSZip();
            const qrFolder = zip.folder("QR_Codes");

            for (let index = 0; index < allData.length; index++) {
                const row = allData[index];

                if (!row.qr) continue;

                const imageBlob = await createQRImageWithCode(
                    row.qr,
                    row.code || `QR_${index + 1}`
                );

                const arrayBuffer = await imageBlob.arrayBuffer();

                const fileName = row.code
                    ? `${row.code}.png`
                    : `qr_${index + 1}.png`;

                qrFolder.file(fileName, arrayBuffer);
            }

            const zipBlob = await zip.generateAsync({
                type: "blob",
            });

            saveAs(zipBlob, "QR_Code_Images.zip");
        } catch (error) {
            console.error("Error generating QR ZIP:", error);
        }
    };

    const createQRImageWithCode = (base64Image, code) => {
        return new Promise((resolve, reject) => {
            const img = new Image();

            img.onload = () => {
                const padding = 20;
                const textAreaHeight = 50;

                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");

                canvas.width = img.width + padding * 2;
                canvas.height =
                    img.height +
                    textAreaHeight +
                    padding * 2;

                // White background
                ctx.fillStyle = "#FFFFFF";
                ctx.fillRect(
                    0,
                    0,
                    canvas.width,
                    canvas.height
                );

                // Draw QR Image
                ctx.drawImage(
                    img,
                    padding,
                    padding,
                    img.width,
                    img.height
                );

                // Optional separator line
                ctx.beginPath();
                ctx.moveTo(
                    padding,
                    img.height + padding + 5
                );
                ctx.lineTo(
                    canvas.width - padding,
                    img.height + padding + 5
                );
                ctx.strokeStyle = "#000";
                ctx.stroke();

                // Draw code text
                ctx.fillStyle = "#000";
                ctx.font = "bold 30px Arial";
                ctx.textAlign = "center";

                ctx.fillText(
                    code,
                    canvas.width / 2,
                    img.height + padding + 35
                );

                canvas.toBlob(
                    (blob) => {
                        if (blob) {
                            resolve(blob);
                        } else {
                            reject(
                                new Error(
                                    "Failed to create image blob"
                                )
                            );
                        }
                    },
                    "image/png",
                    1
                );
            };

            img.onerror = reject;

            img.src = base64Image.startsWith("data:image")
                ? base64Image
                : `data:image/png;base64,${base64Image}`;
        });
    };

    return (
        <>
            <Header name={"QR Codes"} />
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="dashboard__transactionsCard">
                        <div className="dashboard__header">
                            <div className="dashboard__left">
                                <h4 id='transction_list'>All QR Code List</h4>
                            </div>
                            <div className="dashboard__right d-flex gap-2">
                                <button
                                    className="btn btn-primary d-flex align-items-center"
                                    onClick={handleDownloadCSV}
                                >
                                    <span>Download QR Code list</span>
                                    <i className="fa-solid fa-file-excel fa-lg ms-2"></i>
                                </button>

                                {(decrypt(merCode) !== starblazeMerchantId) && <button
                                    className="btn btn-success d-flex align-items-center"
                                    onClick={handleDownloadQRImagesZip}
                                >
                                    <span>Download QR Images</span>
                                    <i className="fa-solid fa-file-zipper fa-lg ms-2"></i>
                                </button>}
                            </div>
                        </div>
                        <div className="dashboard__body">
                            <div className="dashboard__heading" style={{ justifyContent: "end", marginBottom: "0" }}>
                                <div className="dashboard__headingRight">
                                    <div className="form-group">
                                    </div>
                                </div>
                            </div>
                            <Paginated
                                data={filteredData}
                                originalData={data}
                                setFilteredData={setFilteredData}
                                columns={COLUMNS}
                                templateList={templateList}
                                fetch={fetchQRList}
                                qrCount={qrCount}
                                selectedTemplate={selectedTemplate}
                                setSelectedTemplate={setSelectedTemplate}
                                selectedBatch={selectedBatch}
                                setSelectedBatch={setSelectedBatch}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Modal Modal
                show={showModal}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title style={{ fontSize: "16px", fontWeight: 600 }}>
                        Reverse Scan
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Do you want to reverse the scan for QR Code: <strong>{selectedQR?.code}</strong>?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Close</Button>
                    <Button variant="primary" onClick={() => {
                        updateQRCodeStatus()
                        handleClose();
                    }}>Reverse Scan</Button>
                </Modal.Footer>
            </Modal >
        </>
    );
};

export default QRCodeList